import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import { GetSerializedById } from "../../api";
import { Header, Button } from "../../components";
import "../../styles/AddPart.css";
import { Container, Col, Row } from "react-bootstrap";
import TextAreaField from "../../components/TextAreaField";
import TextInputField from "../../components/TextInputField";

const ViewSerialized = () => {
  const navigate = useNavigate();
  let param = useParams();
  const sn_id = param.p_id;
  const [formData, setFormData] = useState({
    part_number: "",
    description: "",
    sn: "",
    mfg_sn: "",
    so_id: "",
    parent_sn: "",
    physical_location: "",
    inkit_status: "",
    kit_id: "",
    ship_date: "",
    po_id: "",
    slot: "",
    note: "",
  });

  const handleBackClick = () => {
    TimeoutUtility.resetTimeout();
    navigate("/Serialized");
  };

  useEffect(() => {
    async function fetchData() {
      if (sn_id) {
        TimeoutUtility.resetTimeout();
        await GetSerializedById(sn_id)
          .then((result) => {
            setFormData({
              part_number: result.data.part_number,
              description: result.data.description,
              sn: result.data.sn,
              mfg_sn: result.data.mfg_sn,
              so_id: result.data.so_id,
              parent_sn: result.data.parent_sn,
              physical_location: result.data.physical_location,
              inkit_status: result.data.inkit_status,
              kit_id: result.data.kit_id,
              ship_date: result.data.ship_date,
              po_id: result.data.po_id,
              slot: result.data.slot,
              note: result.data.note,
            });
          })
          .catch((err) => console.log(err.message));
      }
    }
    fetchData();
  }, [sn_id]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      <Header title="VIEW SERIALIZED PART" />
      <form>
        <Container className="g-0 form-container" fluid="true">
          <Row xs={1} sm={1} className="p-0 justify-content-center">
            <Col md={6} className="container-col">
              <div className="col-lg-12">
                <TextInputField
                  label="SN:"
                  name="sn"
                  value={formData.sn}
                  placeholder="SN"
                  disabled
                />
                <TextInputField
                  label="Mfg SN:"
                  name="mfg_sn"
                  value={formData.mfg_sn}
                  placeholder="Mfg SN"
                  disabled
                />
                <TextAreaField
                  label="Notes:"
                  name="note"
                  value={formData.note}
                  placeholder="Serialized Part Notes"
                  disabled
                />
              </div>
            </Col>
            <Col md={6} className="container-col">
              <div className="col-lg-12">
                <TextInputField
                  label="Part Number:"
                  name="part_number"
                  value={formData.part_number}
                  placeholder="Part Number"
                  disabled
                />
                <TextInputField
                  label="Description:"
                  name="description"
                  value={formData.description}
                  placeholder="Description"
                  disabled
                />
                <TextInputField
                  label="SO #:"
                  name="so_id"
                  value={formData.so_id}
                  placeholder="SO #"
                  disabled
                />
                <TextInputField
                  label="Parent SN:"
                  name="parent_sn"
                  value={formData.parent_sn}
                  placeholder="Parent SN"
                  disabled
                />
                <TextInputField
                  label="Physical Location:"
                  name="physical_location"
                  value={formData.physical_location}
                  placeholder="Physical Location"
                  disabled
                />
                <TextInputField
                  label="In-Kit Status:"
                  name="inkit_status"
                  value={formData.inkit_status}
                  placeholder="In-Kit Status"
                  disabled
                />
                <TextInputField
                  label="Kit #:"
                  name="kit_id"
                  value={formData.kit_id}
                  placeholder="Kit #"
                  disabled
                />
                <TextInputField
                  label="Ship Date:"
                  name="ship_date"
                  value={formData.ship_date}
                  placeholder="Ship Date"
                  disabled
                />
                <TextInputField
                  label="PO #:"
                  name="po_id"
                  value={formData.po_id}
                  placeholder="PO #"
                  disabled
                />
                <TextInputField
                  label="Slot:"
                  name="slot"
                  value={formData.slot}
                  placeholder="Slot"
                  disabled
                />
              </div>
            </Col>
          </Row>
        </Container>
      </form>
      <Row md={"auto"} className="justify-content-center pt-12">
        <Button
          margin="10px"
          padding="20px"
          text="Back"
          onClick={handleBackClick}
        />
      </Row>
    </div>
  );
};

export default ViewSerialized;
